// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___1-w6o","input":"styles-module__input___2yrST","label":"styles-module__label___1OSEa"};